import React from "react";
import PageNotFoundComponent from "../components/PageNotFound";
import NavBar from "../components/NavBar";

const PageNotFound = () => {
  return (
    <>
      <NavBar />
      <PageNotFoundComponent />
    </>
  );
};

export default PageNotFound;
